export default {
  home: 'Accueil',
  form_demo: 'Formulaire démo',
  uiKit: 'UI Kit',
};



// WEBPACK FOOTER //
// ./src/config/locales/fr/nav.js